var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTreatment = function SvgTreatment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44555 7.79661C9.44555 8.9996 7.25696 10.1303 6.16267 10.2041L6.1626 15.2061C6.1626 18.4354 8.84091 21.0532 12.1448 21.0532C15.4486 21.0532 18.127 18.4354 18.127 15.2061L18.127 11.6353C15.2332 11.5463 8.91451 10.0276 8.91451 5.31543",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.075 18.6863C21.2286 18.2401 21.2286 11.644 21.2286 10.44C21.2286 5.42328 17.1618 1.35645 12.1451 1.35645C7.12836 1.35645 3.06152 5.42328 3.06152 10.44C3.06152 11.644 3.06152 7.99429 3.06152 15.3633C3.06152 22.7323 10.2818 24.0501 12.145 24.0501L12.1451 21.4573",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1553 17.3618C10.5873 17.921 11.3171 18.2885 12.1447 18.2885C12.9722 18.2885 13.702 17.921 14.1341 17.3618",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
};
export default SvgTreatment;